<template>
  <span ref="root" class="min-w-0 flex-1" :style="{ fontSize: `${size}px` }">
    <span
      v-for="(part, i) in parts"
      :key="i"
      class="inline-block"
      :class="breakInside[i] ? '[overflow-wrap:anywhere]' : 'whitespace-nowrap'"
      >{{ part }}</span
    >
  </span>
</template>

<script setup lang="ts">
import { computed, nextTick, onMounted, ref } from 'vue'

const props = defineProps<{
  email: string
  fullSize: number
  floorSize: number
}>()

const root = ref<HTMLElement>()
const size = ref(props.fullSize)
const breakInside = ref([false, false])

const parts = computed(() => {
  const afterAt = props.email.indexOf('@') + 1
  return [props.email.slice(0, afterAt), props.email.slice(afterAt)]
})

const partWidths = () =>
  Array.from(root.value!.children, (part) => (part as HTMLElement).offsetWidth)

const fit = async () => {
  // Glyph widths change once the web font has loaded.
  await document.fonts?.ready
  size.value = props.fullSize
  breakInside.value = [false, false]
  await nextTick()

  const room = root.value!.clientWidth
  const natural = partWidths().reduce((sum, width) => sum + width, 0)
  const scale = natural > room ? room / natural : 1
  size.value = Math.max(props.floorSize, Math.floor(props.fullSize * scale))
  await nextTick()

  breakInside.value = partWidths().map((width) => width > room)
}

let fitted: Promise<void> = Promise.resolve()
onMounted(() => {
  fitted = fit()
})

defineExpose({ whenFitted: () => fitted })
</script>
